import { useQuery } from '@tanstack/react-query';

import apiRequest from 'helpers/apiRequest';
import { onError, onSuccessFetch } from './requestResponse';


/*
 * All these functions can be accessed using the available response keys.
 * data, error, isPending, mutate, data, error, isLoading,....
 */

export function FetchAllData<T>(options: {
  url?: string;
  otherQueryKeys?: T[];
  params?: Record<string, any>;
  enabled?: boolean | undefined;
  time?: number;
  refetchInterval?: number;
}) {
  const queryKeys = options.otherQueryKeys || [];
  return useQuery({
    queryKey: [options.url, options.params, ...queryKeys],
    staleTime: options.time || 60 * 1000,
    enabled: options.enabled,
    refetchInterval: options.refetchInterval,
    refetchOnMount: false,
    queryFn: () =>
      apiRequest({ url: options.url, method: 'GET', params: options.params })
        .then(onSuccessFetch)
        .catch(onError),
  });
}

export function FetchData<T>(options: {
  url?: string;
  payload?: T;
  otherQueryKeys?: T[];
  enabled?: boolean | undefined;
  time?: number;
}) {
  const queryKeys = options.otherQueryKeys || [];
  const payload = options.payload;

  return useQuery({
    queryKey: [options.url, options.payload, ...queryKeys],
    staleTime: options.time || 1000 * 60 * 60,
    enabled: options.enabled,
    refetchOnMount: false,
    queryFn: async () =>
      apiRequest({
        url: options.url,
        method: 'POST',
        payload: payload,
      })
        .then(onSuccessFetch)
        .catch(onError),
  });
}